export function normalizeId(id) {
  if (id == null || id === '') return '';
  if (typeof id === 'object') {
    if (id.$oid) return String(id.$oid);
    if (id.toString && id.toString() !== '[object Object]') return String(id);
    return '';
  }
  return String(id);
}

export function getOptionId(option, index = 0) {
  return normalizeId(option?._id ?? option?.id ?? `option-${index}`);
}

export function isSameId(left, right) {
  return normalizeId(left) === normalizeId(right);
}

export function getOptionLabel(option) {
  return option?.text ?? option?.answer ?? '';
}

export function getEmojiImageKey(option) {
  const raw = option?.value ?? option?.text;
  const parsed = Number.parseInt(String(raw), 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
}
